/*
  utils.js

  GridStack 플러그인의 Util 모음

  NGF 1.2.0 수정 이력

  1) 대시보드 위젯 옵션 수정 시 페이지 이동을 감지하는 이벤트 생성 및 소멸 추가
*/

/*
  이름 : createGridLayout
  설명 : 그리드 레이아웃을 생성한다.
*/
export function createGridLayout (target, options = {}, onMoveWidgetFunction = null, onResizeWidgetFunction = null) {
  // 그리드 스택 연결
  $(target).gridstack(options)

  // 개별 위젯 이동 확정 시 이벤트 연결
  $(target).on('movenode', (event, element) => {
    if (onMoveWidgetFunction) {
      onMoveWidgetFunction(event, element)
    }
  })

  // 개별 위젯 리사이즈 이벤트 연결 (위젯 내부에서 브라우저의 Resize 이벤트가 감지가 안되는 특징이 있어, 위젯 리사이즈 시 강제로 브라우저 리사이즈 호출)
  $(target).on('gsresizestop', function (event, element) {
    // 브라우저 Resize 호출 > 위젯 내부 컨텐츠 정렬
    window.dispatchEvent(new CustomEvent('resize', {
      targetElement: element
    }))

    if (onResizeWidgetFunction) {
      onResizeWidgetFunction(event, element)
    }
  })
}

/*
  이름 : getLayoutColumn
  설명 : 현재 레이아웃에 설정된 컬럼 갯수를 리턴한다.
*/
export function getLayoutColumn (target) {
  // 레이아웃 가져오기
  const layout = $(target).data('gridstack')
  // 레이아웃 컬럼 갯수 리턴
  return layout.getGridWidth()
}

/*
  이름 : setLayoutColumns
  설명 : 현재 레이아웃의 기준이되는 컬럼 갯수를 설정한다.
*/
export function setLayoutColumns (target, columns) {
  // 레이아웃 가져오기
  const layout = $(target).data('gridstack')
  // 레이아웃 컬럼설정
  layout.setGridWidth(columns)
}

/*
  이름 : addWidget
  설명 : Vue에서 추가된 위젯을 GridStack 위젯으로 변환한다.
*/
export function addWidget (target, el, x, y, width, height, autoPosition, minWidth, maxWidth, minHeight, maxHeight, id) {
  // 레이아웃 가져오기
  const layout = $(target).data('gridstack')
  // 위젯클래스 맵핑
  layout.addWidget(el, x, y, width, height, autoPosition, minWidth, maxWidth, minHeight, maxHeight, id)
}

/*
  이름 : makeWidget
  설명 :  Vue에서 추가된 위젯을 GridStack 위젯으로 변환한다.
*/
export function makeWidget (target, widgetId) {
  // 레이아웃 가져오기
  const layout = $(target).data('gridstack')
  // 위젯클래스 맵핑
  layout.makeWidget(widgetId)
}

/*
  이름 : lockWidget
  설명 : 해당 위젯을 잠금처리한다. 잠금 처리된 위젯은 Move, Resize가 제한된다.
*/
export function lockWidget (target, el, locked = true) {
  // 레이아웃 가져오기
  const layout = $(target).data('gridstack')
  // 위젯클래스 맵핑
  layout.locked(el, locked)
}

/*
  이름 : movableWidget
  설명 : 해당 위젯의 드래그를 통한 움직임을 허용한다.
*/
export function movableWidget (target, el, movable = true) {
  // 레이아웃 가져오기
  const layout = $(target).data('gridstack')
  // 위젯클래스 맵핑
  layout.movable(el, movable)
}

/*
  이름 : resizableWidget
  설명 : 해당 위젯의 드래그를 통한 리사이즈를 허용한다.
*/
export function resizableWidget (target, el, resizable = true) {
  // 레이아웃 가져오기
  const layout = $(target).data('gridstack')
  // 위젯클래스 맵핑
  layout.resizable(el, resizable)
}

/*
  이름 : removeWidget
  설명 : 해당 위젯을 삭제한다. Vue 컴포넌트가 제거되면 JQuery 내부 Data에서 제거한다.
*/
export function removeWidget (target, el, options = true) {
  // 레이아웃 가져오기
  const layout = $(target).data('gridstack')
  // 위젯 제거
  layout.removeWidget(el, options)
}

/*
  이름 : removeAllWidgets
  설명 : 모든 위젯을 제거한다.
*/
export function removeAllWidgets (target) {
  // 레이아웃 가져오기
  const layout = $(target).data('gridstack')
  // 모든 위젯 제거
  layout.removeAll()
}

/*
  이름 : getCurrentWidgetsLayout
  설명 : 대시보드 저장 시 현재 레이아웃에 등록된 위젯의 속성을 가져와 리턴한다.
*/
export function getCurrentWidgetsLayout (target) {
  // 1. 활성화 되어있는 위젯정보 가져오기
  const widgets = []
  // 2. 레이아웃 객체 가져오기
  const layout = $(target).data('gridstack')
  // 3. 활성화 되어있는 위젯 깊은복사
  const copyWidgets = layout.grid.nodes.slice()
  // 4. 위젯들을 저장에 필요한 포맷으로 변경
  for (const widget of copyWidgets) {
    // 4-1. Inner 컨텐츠 요소 가져오기
    const contentsEl = widget.el[0]
    // 4-2. 위젯의 innerComponent 객체 가져오기
    const vueInstance = contentsEl.widget
    // 4-3. 변경된 포맷으로 위젯 추가
    /*
      i: 위젯의 아이디,
      w: 위젯의 너비 (1 ~ 3),
      s: 차트의 순번,
      n: 위젯 콘텐츠가 중복될 경우,
      opts: 위젯의 엑스트라 옵션 (Ex. 차트의 단위를 Bps로 할 것인지, Pps로 할 것인지 여부) -> 객체의 형태로 전달되며 위젯이 마운트 될 때 initOptions에 초기화된다,
      title: 위젯의 타이틀 문자열. i18n의 키 값으로 사용,
      isLock: 위젯의 잠금 여부 (예비용 멤버 변수),
      isMove: 위젯의 드래그 여부 (예비용 멤버 변수),
      isResize: 위젯의 리사이즈 여부 (예비용 멤버 변수),
      contents: 위젯 내부에 들어가는 실제 컨텐츠 내용. WidgetDrawer의 target이 들어가며, 실제 파일의 이름을 나타냄
      chartType: 마지막으로 설정한 차트 타입 (추이차트, 다중 Series, 데이터 테이블, 실시간 위젯인 경우에는 null)
    */
    // 4-4. Dashboard Component에 전달할 위젯 리스트 추가
    const splitWidgetId = contentsEl.id.split('_')

    // 4-5. 위젯 넘버링 저장 > 문자열로 저장함 (대시보드 레이아웃에 큰 영향을 미치는 옵션이 아니므로 GridStack 엔진에서 따로 추가하지 않음)
    const widgetNum = $(widget.el).attr('data-gs-n') || ''

    widgets.push({
      i: contentsEl.id,
      w: widget.width,
      s: widget.seq,
      n: widgetNum,
      opts: vueInstance.opts,
      title: vueInstance.title,
      isLock: vueInstance.isLock,
      isMove: vueInstance.isMove,
      isResize: vueInstance.isResize,
      contents: splitWidgetId[1]
    })
  }
  return widgets
}

/*
  이름 : onResizeEventHandler
  설명 : 위젯의 리사이즈에 관련된 이벤트 핸들러를 연결한다.
*/

export function onResizeEventHandler (target, event = 'resizestart', handler = function () {}) {
  $(target).on(event, handler)
}

/*
  이름 : offResizeEventHandler
  설명 : 연결되어있는 이벤트를 제거한다.
*/
export function offResizeEventHandler (target, event = 'resizestart', handler = function () {}) {
  $(target).off(event)
}

/*
  이름 : destroyGridLayout
  설명 : 그리드 레이아웃 인스턴스를 파괴한다.
*/
export function destroyGridLayout (target) {
  // 레이아웃 가져오기
  const layout = $(target).data('gridstack')

  // 레이아웃이 Mounted 되어있는 경우에만 Destroy 호출
  if (layout) {
    layout.destroy()
  }

  // 위젯 개별 리사이즈 이벤트 제거
  $(target).off('movenode')
  $(target).off('gsresizestop')
}
